<div class="body">

    <div class="btn-options">
        <button color="primary" (click)="close()" mat-icon-button matTooltip="Fechar">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div class="titulo">
        <p class="p-titulo">
            Atenção!
        </p>
    </div>

    <div class="subtitulo">
        <p class="p-subtitulo">
            Confirme Com O Aluno O CELULAR E O EMAIL
        </p>
    </div>

    <div class="div-celular-email" fxLayout="row">
        <div class="celular" fxFlex="50">
            <p class="p-celular">
                Celular:
                {{ dadosContato.contato.celular }}
            </p>

            <button mat-raised-button class="alterar-celular" (click)="alterarCelular()">
                Alterar Celular
            </button>
        </div>

        <div class="email" fxFlex="50">
            <p class="p-email">
                Email:
                {{ dadosContato.contato.email }}
            </p>

            <button mat-raised-button class="alterar-email" (click)="alterarEmail()">
                Alterar Email
            </button>
        </div>
    </div>

    <mat-divider></mat-divider>

    <!-- <div class="finalizacao">
        <p class="p-final">
            O Celular e o Email estão corretos?
        </p>
    </div>

    <div class="div-botoes-sim-nao">
        <button mat-raised-button class="botao-sim">
            Sim
        </button>

        <button mat-raised-button class="botao-nao">
            Não
        </button>
    </div> -->

    <div fxLayout="row">
        <div class="finalizacao" fxFlex="85">
            <p class="p-final">
                O Celular E O Email Estão Corretos!
            </p>
        </div>

        <div class="div-botao-ok" fxFlex="15">
            <button mat-raised-button class="botao-ok" (click)="close()">
                Ok
            </button>
        </div>
    </div>
</div>